import { Text } from 'react-native'
import { styled } from '~/core/styled'

import { convertLineHeight, convertPercentageToNumber } from '~/utils'

type SubtitleProps = React.ComponentPropsWithRef<typeof Subtitle>

const Subtitle = styled(Text, theme => {
  return {
    base: {
      fontSize: theme.fontSizeFourpulse,
      fontFamily: theme.fontFamily.bold,
      color: theme.colorTextNeutralDefault,

      lineHeight: convertLineHeight(
        theme.fontSizeFourpulse,
        theme.lineHeightSmall
      ),
      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),
      textDecorationLine: theme.textDecorationLineNone,
    },
    variants: {
      variant: {
        'default-bold': {},
        'underline-bold': {
          textDecorationLine: theme.textDecorationLineUnderline,
        },
        'default-regular': {
          fontFamily: theme.fontFamily.regular,
        },
      },
    },
  }
})

export { Subtitle }
export type { SubtitleProps }
